import "./jini.scss";

document.addEventListener("DOMContentLoaded", function () {
	let jiniEl = document.getElementById("jini-action");
	if (null != jiniEl) {
		jiniEl.addEventListener("click", sendToJini);
	}
	let jiniBlurb = document.querySelectorAll(".rentalz-blurbs a");
	if (jiniBlurb.length > 0)
		jiniBlurb[0].addEventListener("click", sendToJini);

	// look for links on the destination page(s)
	let jiniMenuItem = document.querySelector(".jini-menu a");
	if (null != jiniMenuItem) {
		if (typeof window.affiliateURLdecorator === "function") {
			jiniMenuItem.href = window.affiliateURLdecorator(jiniMenuItem.href);
		}
	}
});
function sendToJini(e) {
	e.preventDefault();

	let url = "https://jini.rentalz.com";
	if (typeof window.affiliateURLdecorator === "function") {
		// add the ref/irclickid parameters if they exist
		url = window.affiliateURLdecorator(url);
	}

	let theURL = new URL(url);
	let params = {
		city: "",
		state: "",
		arrival: "",
		departure: "",
		guests: "",
		icnd: "",
		phoneNumber: "",
	};

	let icndForm = document.getElementById("quickSearchBE");
	if (null != icndForm) {
		params = parseICNDform(params);
		let thisPage = new URL(window.location.href);
		let pathComponents = thisPage.pathname.split("/");
		params.city = properCase(pathComponents[3]);
		params.state = properCase(pathComponents[2]);
	}

	params.phoneNumber = document.getElementsByClassName(
		"be-header-phone-number-text"
	)[0].textContent;

	/**
	 * Build and open jini
	 */
	Object.keys(params).forEach((param) => {
		if ("" != params[param])
			theURL.searchParams.append(param, params[param]);
	});

	window.open(theURL.href, "_blank");
}
function parseICNDform(params) {
	// responsible for dates, icnd url, ref, and irclickid & guest count
	let map = {
		arrivalDate: "arrival",
		departureDate: "departure",
		guests: "guests",
	};
	Object.keys(map).forEach((param) => {
		let field = document.getElementById(param);
		//		console.log("#" + param, field.value);
		if (null != field) params[map[param]] = field.value;
	});
	params.icnd = document.querySelector("#icnd-search form").action;
	return params;
}

function properCase(mySentence) {
	let words = mySentence.replace(new RegExp("-", "g"), " ").split(" ");

	for (let i = 0; i < words.length; i++) {
		words[i] = words[i][0].toUpperCase() + words[i].substr(1);
	}

	return words.join(" ");
}
